import React from 'react'

export default function CenterLogo() {
    return (
        <div className='centerlogo'>
            <h1>Random Anime Generator </h1> 
        </div>
    )
}
